import { getPrice } from '@fourthwall/utils'

export const getProfitCopy = (value: number) => {
  if (isNaN(value)) {
    return 'Enter selling price.'
  }

  const absoluteProfit = getPrice(Math.abs(value))

  return `You'll ${value < 0 ? 'lose' : 'make'} ${absoluteProfit} per sale${value > 2 ? '!' : '.'}`
}
